import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import {
  DELETE_CLASS_MODAL_STAGES,
  deleteSbatGroupCommunicationsSelector,
  deleteSbatGroupErrorMessageSelector,
  deleteReasonSelector,
  resetDeleteModal,
  selectedDeleteSbatGroupSelector,
  setDeleteClassModalStage,
  useDeleteSbatGroupMutation,
} from 'features/classCreation';

export default function DeleteClassModalValidationStage() {
  const dispatch = useDispatch();
  const selectedSbatGroup = useSelector(selectedDeleteSbatGroupSelector);
  const communications = useSelector(deleteSbatGroupCommunicationsSelector);
  const deleteReason = useSelector(deleteReasonSelector);
  const errorMessage = useSelector(deleteSbatGroupErrorMessageSelector);
  const [deleteSbatGroup, { isSuccess, error, isLoading }] =
    useDeleteSbatGroupMutation();

  const handleCancel = useCallback(() => {
    dispatch(setDeleteClassModalStage(DELETE_CLASS_MODAL_STAGES.reason));
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Class is successfully cancelled!');
      dispatch(resetDeleteModal());
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in cancelling the class. Please try again later!'
      );
    }
  }, [error]);

  const handleConfirm = useCallback(() => {
    const comms = Object.keys(communications).filter(
      (key) => communications[key]
    );

    deleteSbatGroup({
      sbatGroupId: selectedSbatGroup.id,
      comms,
      reason: deleteReason?.label,
    });
  }, [
    communications,
    deleteReason?.label,
    deleteSbatGroup,
    selectedSbatGroup.id,
  ]);

  return (
    <div className="column justify-c align-c">
      <div className="row">
        <Icon
          name="warning"
          className="h2 m-r-xxs danger"
        />
        <div className="dark h4 text-c m-b-m">{errorMessage}</div>
      </div>
      <div>
        <Tappable
          className="btn btn-danger btn-long"
          onClick={handleConfirm}
          disabled={isLoading}
        >
          Yes
        </Tappable>
        <Tappable
          className="btn btn-long m-l-xxs"
          onClick={handleCancel}
          disabled={isLoading}
        >
          No
        </Tappable>
      </div>
    </div>
  );
}
